import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Section from '../Section';
import CauseMarketing from '../CauseMarketing';

export function HomeDifferenceSection(): JSX.Element {
  return (
    <Section className='home-difference mb-5'>
      <Row>
        <Col>
          <h2>Powered by Caring:</h2>
          <h3>
            We're committed to compassion - inside our walls and beyond.
          </h3>
          <p>
            At the heart of Two Maids is a team that believes in lifting each other up and giving back. We foster 
            an internal culture of connection and grit, and proudly extend that spirit into the communities we serve. 
            We're honored to support nonprofit organizations that reflect our values and make meaningful impacts in the 
            lives of others.
          </p>
          <p>
            For more about these organizations, please visit their official websites linked below:
          </p>
        </Col>
      </Row>
      <CauseMarketing />
    </Section>
  );
}
